if (!customElements.get('novarail-brightness-info')) {
  customElements.define('novarail-brightness-info', class extends HTMLElement {
    connectedCallback() {
      this.trigger = this.querySelector('.novarail-brightness__label');
      this.panel = this.querySelector('.novarail-brightness__panel');
      if (!this.trigger || !this.panel) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.nativePopover = typeof this.panel.showPopover === 'function';
      if (!this.nativePopover) this.panel.hidden = true;
      this.pinned = false;
      this.trigger.addEventListener('click', event => {
        event.preventDefault();
        if (this.isOpen && this.pinned) this.close();
        else { this.pinned = true; this.open(); }
      }, options);
      this.querySelector('.novarail-brightness__close').addEventListener('click', event => {
        event.preventDefault();
        this.close();
        this.trigger.focus({ preventScroll: true });
      }, options);
      for (const element of [this.trigger, this.panel]) {
        element.addEventListener('pointerenter', event => {
          this.clearCloseTimer();
          if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) this.open();
        }, options);
        element.addEventListener('pointerleave', () => this.scheduleClose(), options);
      }
      this.addEventListener('focusout', () => {
        queueMicrotask(() => {
          if (!this.contains(document.activeElement) && !this.pinned) this.close();
        });
      }, options);
      this.panel.addEventListener('toggle', event => {
        if (event.newState === 'closed') this.pinned = false;
        this.trigger.setAttribute('aria-expanded', String(event.newState === 'open'));
      }, options);
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && this.isOpen) this.close();
      }, options);
      document.addEventListener('pointerdown', event => {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }, options);
      window.addEventListener('resize', () => this.position(), options);
      window.addEventListener('scroll', () => this.position(), { ...options, capture: true, passive: true });
    }
    disconnectedCallback() {
      this.clearCloseTimer();
      this.controller?.abort();
    }
    get isOpen() {
      return this.nativePopover ? this.panel.matches(':popover-open') : !this.panel.hidden;
    }
    open() {
      this.clearCloseTimer();
      if (!this.isOpen) {
        if (this.nativePopover) this.panel.showPopover();
        else this.panel.hidden = false;
      }
      this.trigger.setAttribute('aria-expanded', 'true');
      this.position();
    }
    close() {
      this.clearCloseTimer();
      this.pinned = false;
      if (this.isOpen) {
        if (this.nativePopover) this.panel.hidePopover();
        else this.panel.hidden = true;
      }
      this.trigger.setAttribute('aria-expanded', 'false');
    }
    clearCloseTimer() { clearTimeout(this.closeTimer); }
    scheduleClose() {
      this.clearCloseTimer();
      this.closeTimer = setTimeout(() => {
        if (!this.pinned && !this.panel.contains(document.activeElement)) this.close();
      }, 220);
    }
    position() {
      if (!this.isOpen) return;
      const trigger = this.trigger.getBoundingClientRect();
      const panel = this.panel.getBoundingClientRect();
      const width = document.documentElement.clientWidth;
      const height = window.innerHeight;
      const left = Math.max(12, Math.min(trigger.left, width - panel.width - 12));
      let top = trigger.bottom + 8;
      if (top + panel.height > height - 12 && trigger.top - panel.height - 8 >= 12) {
        top = trigger.top - panel.height - 8;
      }
      top = Math.max(12, Math.min(top, height - panel.height - 12));
      this.panel.style.left = left + 'px';
      this.panel.style.top = top + 'px';
    }
  });
}
